const isLocalizationForm = (form) =>
  form instanceof HTMLFormElement && form.querySelector('[name="form_type"]')?.value === 'localization';

const currentReturnTo = () => window.location.pathname + window.location.search + window.location.hash;

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!isLocalizationForm(form)) return;
  const fields = form.querySelectorAll('[name="return_to"]');
  if (!fields.length) {
    const field = document.createElement('input');
    field.type = 'hidden';
    field.name = 'return_to';
    form.append(field);
  }
  for (const field of form.querySelectorAll('[name="return_to"]')) field.value = currentReturnTo();
}, { capture: true });

document.addEventListener('formdata', (event) => {
  if (isLocalizationForm(event.target)) event.formData.set('return_to', currentReturnTo());
}, { capture: true });
